var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-controls", attrs: { id: "header__controls" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-7 col-md-8 col-8 left-side" }, [
            _vm.$router.currentRoute.name == "globalAlert"
              ? _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "header-filter-btns",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("createNewAlert")
                          }
                        }
                      },
                      [
                        _vm._v("\n            Add Alert\n            "),
                        _c("i", {
                          staticClass: "fas text-primary fa-plus fa-fw"
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$router.currentRoute.name == "userGlobalAlert"
              ? _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("div", { staticClass: "input-group top-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.notificationFilters.query,
                            expression: "notificationFilters.query"
                          },
                          {
                            name: "debounce",
                            rawName: "v-debounce:500ms",
                            value: _vm.handleNotificationSearchChange,
                            expression: "handleNotificationSearchChange",
                            arg: "500ms"
                          }
                        ],
                        staticClass: "form-control media-calls-search",
                        attrs: {
                          type: "text",
                          "debounce-events": ["keyup"],
                          placeholder: "Search notifications..."
                        },
                        domProps: { value: _vm.notificationFilters.query },
                        on: {
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleNotificationFilterChange.apply(
                              null,
                              arguments
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.notificationFilters,
                              "query",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-group-append cursor-pointer",
                          on: { click: _vm.handleNotificationFilterChange }
                        },
                        [_vm._m(0)]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        ref: "notificationFilterBoxBtn",
                        staticClass: "ml-2 header-filter-btns",
                        attrs: {
                          id: "notificationFilterButton",
                          variant: "theme",
                          tabindex: "0",
                          href: "#"
                        },
                        on: {
                          keydown: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape"
                              ])
                            ) {
                              return null
                            }
                            _vm.$refs.notificationFilterPopover &&
                              _vm.$refs.notificationFilterPopover.$emit("close")
                          }
                        }
                      },
                      [
                        _c("span", [_vm._v("Filter")]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("@/csmworkflow/img/filter.svg")
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "notificationFilterPopover",
                        attrs: {
                          show: _vm.notificationFilterPopoverOpen,
                          triggers: "click",
                          boundary: "window",
                          placement: "bottom",
                          target: "notificationFilterButton",
                          "custom-class":
                            "deliverable-filter notification-filter"
                        },
                        on: {
                          "update:show": function($event) {
                            _vm.notificationFilterPopoverOpen = $event
                          },
                          shown: _vm.onNotificationFilterPopoverShown,
                          hidden: _vm.onNotificationFilterPopoverHidden
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "item__reset" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "notification-reset-btn",
                                attrs: {
                                  variant: "theme",
                                  title: "Reset All Filter",
                                  size: "sm"
                                },
                                on: {
                                  click: _vm.clearNotificationFilterPopover
                                }
                              },
                              [_c("i", { staticClass: "fas fa-undo" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "d-block d-lg-none",
                                attrs: {
                                  variant: "theme",
                                  title: "Close Filter Popup",
                                  size: "sm"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.$refs.notificationFilterPopover &&
                                      _vm.$refs.notificationFilterPopover.$emit(
                                        "close"
                                      )
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-times" })]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item item__status" },
                            [
                              _c("label", [_vm._v("Status")]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "status-wrap" },
                                _vm._l(_vm.notificationStatuses, function(
                                  s,
                                  index
                                ) {
                                  return _c(
                                    "a",
                                    {
                                      key: index,
                                      staticClass: "badge mr-2",
                                      style: {
                                        cursor: "pointer",
                                        color: "var(--wf-secondary)",
                                        backgroundColor: s.color,
                                        opacity:
                                          _vm.notificationFilters.status ===
                                          s.value
                                            ? 1
                                            : 0.65
                                      },
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.setNotificationStatusBadge(
                                            s.value
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(s.name))]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "filter-item item__notification-category"
                            },
                            [
                              _c("label", [_vm._v("Category")]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-field" },
                                [
                                  _c("multiselect", {
                                    attrs: {
                                      options: _vm.groupedModelOptions,
                                      "show-labels": false,
                                      multiple: false,
                                      "allow-empty": false,
                                      placeholder: "Select category",
                                      "track-by": "value",
                                      label: "text",
                                      "open-direction": "bottom"
                                    },
                                    on: { input: _vm.handleGroupedModelChange },
                                    model: {
                                      value: _vm.selectedGroupedModel,
                                      callback: function($$v) {
                                        _vm.selectedGroupedModel = $$v
                                      },
                                      expression: "selectedGroupedModel"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "filter-item item__notification-created-date filter-item-no-border"
                            },
                            [
                              _c(
                                "div",
                                [
                                  _c("label", [_vm._v("Created")]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("date-range-picker", {
                                    ref: "pickerNotificationDateCreated",
                                    attrs: {
                                      autoApply: true,
                                      ranges: _vm.customNotificationDateRanges
                                    },
                                    on: {
                                      update:
                                        _vm.onUpdateNotificationDateCreated
                                    },
                                    model: {
                                      value: _vm.notificationFilters.dateRange,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.notificationFilters,
                                          "dateRange",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notificationFilters.dateRange"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.activeNotificationFiltersCount > 0,
                                expression: "activeNotificationFiltersCount > 0"
                              }
                            ],
                            staticClass: "mt-3"
                          },
                          [
                            _c("label", [_vm._v("Click to remove filters :")]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm.notificationFilters.query
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: { click: _vm.clearNotificationSearch }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.notificationFilters.query) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.notificationFilters.status !== "all"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setNotificationStatusFilter(
                                          "all"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.notificationStatusFilterText
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.notificationFilters.filterByDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: _vm.clearNotificationDateFilter
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Created: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.notificationFilters.dateRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.notificationFilters.dateRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.notificationFilters.grouped_model !== "all"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.setNotificationGroupedModel(
                                          "all"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Category: " +
                                        _vm._s(
                                          _vm.formatGroupedModel(
                                            _vm.notificationFilters
                                              .grouped_model
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.selectedNotificationAlertTypeNames,
                              function(alertType) {
                                return _c(
                                  "span",
                                  {
                                    key: alertType.slug,
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeNotificationAlertType(
                                          alertType.slug
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(alertType.type) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "report-type ml-2" },
                      [
                        _c("multiselect", {
                          staticClass: "notification-types-multiselect",
                          attrs: {
                            options: _vm.filteredAlertTypes,
                            "show-labels": false,
                            multiple: true,
                            "allow-empty": true,
                            placeholder: "Filter by notification type",
                            "track-by": "slug",
                            label: "type",
                            "open-direction": "bottom"
                          },
                          on: { input: _vm.handleNotificationFilterChange },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "selection",
                                fn: function(ref) {
                                  var values = ref.values
                                  var search = ref.search
                                  var isOpen = ref.isOpen
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(values.length) +
                                                " type" +
                                                _vm._s(
                                                  values.length > 1 ? "s" : ""
                                                ) +
                                                " selected\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2929034971
                          ),
                          model: {
                            value: _vm.notificationFilters.alert_types,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.notificationFilters,
                                "alert_types",
                                $$v
                              )
                            },
                            expression: "notificationFilters.alert_types"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ml-2 expand-grp" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "header-filter-btns expand-ctrls",
                            class: {
                              "none-active-btn":
                                _vm.notificationFilters.group_by !== "date"
                            },
                            attrs: { variant: "theme", title: "Group by Date" },
                            on: {
                              click: function($event) {
                                return _vm.setNotificationGroupBy("date")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass:
                                  "fas text-primary fa-calendar fa-fw"
                              })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "header-filter-btns expand-ctrls",
                            class: {
                              "none-active-btn":
                                _vm.notificationFilters.group_by !==
                                "deliverable"
                            },
                            attrs: {
                              variant: "theme",
                              title: "Group by Deliverables"
                            },
                            on: {
                              click: function($event) {
                                return _vm.setNotificationGroupBy("deliverable")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("img", {
                                staticStyle: { height: "15px" },
                                attrs: {
                                  src: require("@/csmworkflow/img/project-deliverable-green.svg")
                                }
                              })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "header-filter-btns expand-ctrls",
                            class: {
                              "none-active-btn":
                                _vm.notificationFilters.group_by !== "project"
                            },
                            attrs: {
                              variant: "theme",
                              title: "Group by Projects"
                            },
                            on: {
                              click: function($event) {
                                return _vm.setNotificationGroupBy("project")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", {
                                staticClass: "fas text-primary fa-folder fa-fw"
                              })
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$router.currentRoute.name == "userGlobalAlert" &&
            _vm.activeNotificationFiltersCount > 0
              ? _c(
                  "div",
                  { staticClass: "mt-3 filter-badges" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _vm.notificationFilters.query
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: { click: _vm.clearNotificationSearch }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.notificationFilters.query) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notificationFilters.status !== "all"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.setNotificationStatusFilter("all")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.notificationStatusFilterText) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notificationFilters.filterByDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: { click: _vm.clearNotificationDateFilter }
                          },
                          [
                            _vm._v(
                              "\n            Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.notificationFilters.dateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.notificationFilters.dateRange.endDate,
                                    "MMM DD"
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.notificationFilters.grouped_model !== "all"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.setNotificationGroupedModel("all")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            Category: " +
                                _vm._s(
                                  _vm.formatGroupedModel(
                                    _vm.notificationFilters.grouped_model
                                  )
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.selectedNotificationAlertTypeNames, function(
                      alertType
                    ) {
                      return _c(
                        "span",
                        {
                          key: alertType.slug,
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeNotificationAlertType(
                                alertType.slug
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(alertType.type) +
                              "\n          "
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$router.currentRoute.name != "permissionManager" &&
            _vm.$router.currentRoute.name != "globalAlert" &&
            _vm.$router.currentRoute.name != "userGlobalAlert"
              ? _c(
                  "div",
                  {
                    class:
                      "form-inline " +
                      (_vm.$router.currentRoute.name == "dashboard" ||
                      _vm.$router.currentRoute.name == "myWeek"
                        ? "deliverable-filter-form"
                        : "")
                  },
                  [
                    _c("div", { staticClass: "input-group top-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery"
                          },
                          {
                            name: "debounce",
                            rawName: "v-debounce:500ms",
                            value: _vm.setQuery,
                            expression: "setQuery",
                            arg: "500ms"
                          }
                        ],
                        ref: "searchQuery",
                        staticClass: "form-control",
                        class: _vm.isGlobalSearchRoute
                          ? ""
                          : "media-calls-search",
                        attrs: {
                          type: "text",
                          "debounce-events": ["keyup"],
                          placeholder: _vm.querySearchPlaceHolder,
                          id: "search-query"
                        },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          click: function($event) {
                            return _vm.$refs.searchQuery.select()
                          },
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.triggerSearch.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuery = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-group-append cursor-pointer",
                          on: { click: _vm.triggerSearch }
                        },
                        [_vm._m(1)]
                      )
                    ]),
                    _vm._v(" "),
                    !_vm.isGlobalSearchRoute
                      ? _c(
                          "b-button",
                          {
                            ref: "filterBoxBtn",
                            staticClass: "ml-2 header-filter-btns",
                            attrs: {
                              id: "popover-button-event",
                              variant: "theme",
                              tabindex: "0"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                              },
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "esc",
                                    27,
                                    $event.key,
                                    ["Esc", "Escape"]
                                  )
                                ) {
                                  return null
                                }
                                return _vm.$refs.popover.$emit("close")
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: {
                                  "wider-filter-only":
                                    _vm.$router.currentRoute.name ==
                                      "dashboard" ||
                                    _vm.$router.currentRoute.name == "myWeek"
                                }
                              },
                              [_vm._v("Filter")]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("@/csmworkflow/img/filter.svg")
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          triggers: "click blur",
                          boundary: "window",
                          placement: "bottom",
                          target: "popover-button-event",
                          "custom-class": "deliverable-filter"
                        }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item item__status" },
                            [
                              _c("label", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.getCalendarStatusLabel)
                                }
                              }),
                              _vm._v(" "),
                              !_vm.isMobile()
                                ? _c(
                                    "div",
                                    { staticClass: "status-wrap" },
                                    _vm._l(_vm.statuses, function(s, index) {
                                      return _c(
                                        "a",
                                        {
                                          key: index,
                                          staticClass: "badge mr-2",
                                          style: {
                                            color: "var(--wf-secondary)",
                                            backgroundColor: s.color
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.setStatusFilter(s)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-field status-field" },
                                [
                                  _vm.isMobile()
                                    ? _c("multiselect", {
                                        attrs: {
                                          searchable: true,
                                          label: "name",
                                          options: _vm.statuses,
                                          placeholder: "Select status",
                                          "show-labels": false,
                                          multiple: true,
                                          "hide-selected": true
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "option",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color:
                                                          "var(--wf-secondary)",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        height: "40px",
                                                        lineHeight: "40px",
                                                        textAlign: "center"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "tag",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color:
                                                          "var(--wf-secondary)",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        padding: "5px 10px",
                                                        marginRight: "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1072643857
                                        ),
                                        model: {
                                          value: _vm.filterQuery.status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "status",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.status"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _vm.checkCalendarMode(["deliverables", "tasks"])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__outlet" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("label", [_vm._v("Outlet")]),
                                        _vm._v(" "),
                                        _vm.isMobile()
                                          ? _c(
                                              "b-form-checkbox",
                                              {
                                                staticClass:
                                                  "float-right csm-checkbox",
                                                attrs: {
                                                  id: "no-outlet",
                                                  name: "no-outlet",
                                                  value: "accepted",
                                                  "unchecked-value":
                                                    "not_accepted"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.filterQuery.noOutlet ==
                                                    "accepted"
                                                      ? (_vm.filterQuery.outlet = [])
                                                      : ""
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filterQuery.noOutlet,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filterQuery,
                                                      "noOutlet",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filterQuery.noOutlet"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "No\n                      Outlet"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "outlet-wrap" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            ref: "outletFilter",
                                            attrs: {
                                              "track-by": "id",
                                              "open-direction": "bottom",
                                              label: "name",
                                              options: _vm.contacts,
                                              "show-labels": false,
                                              multiple: true,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": true,
                                              "clear-on-select": false,
                                              "internal-search": false,
                                              loading: _vm.isContactsLoading
                                            },
                                            on: {
                                              select: function($event) {
                                                _vm.filterQuery.noOutlet =
                                                  "not_accepted"
                                              },
                                              "search-change": _vm.onWhoSearch
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var values = ref.values
                                                    var search = ref.search
                                                    var isOpen = ref.isOpen
                                                    return [
                                                      values.length && !isOpen
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiselect__single"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  values.length
                                                                ) +
                                                                  " options\n                          selected"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "option",
                                                  fn: function(props) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "option__desc"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option__title"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option__small text-muted"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .company_name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              3091752966
                                            ),
                                            model: {
                                              value: _vm.filterQuery.outlet,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "outlet",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.outlet"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noOptions" },
                                              [
                                                _vm._v(
                                                  "Start typing to find contacts."
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noResult" },
                                              [
                                                _vm._v(
                                                  "No results. Please try changing the search query."
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass: "mt-2 csm-checkbox",
                                            attrs: {
                                              id: "no-outlet",
                                              name: "no-outlet",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.filterQuery.noOutlet ==
                                                "accepted"
                                                  ? (_vm.filterQuery.outlet = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value: _vm.filterQuery.noOutlet,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "noOutlet",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.noOutlet"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "No\n                    Outlet"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item item__coordinator" },
                              [
                                _c("label", [_vm._v("Assigned To")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "coordinator-wrap" },
                                  [
                                    _c("multiselect", {
                                      ref: "coordinatorFilter",
                                      attrs: {
                                        options: _vm.allActiveUsers,
                                        "show-labels": false,
                                        multiple: true,
                                        "open-direction": "bottom",
                                        label: "name",
                                        "track-by": "id",
                                        "hide-selected": true,
                                        "close-on-select": false,
                                        "clear-on-select": false
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                            " options\n                          selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1090287252
                                      ),
                                      model: {
                                        value: _vm.filterQuery.coordinator,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterQuery,
                                            "coordinator",
                                            $$v
                                          )
                                        },
                                        expression: "filterQuery.coordinator"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.isGlobalSearchRoute &&
                            _vm.$router.currentRoute.name != "mediaCallPage" &&
                            _vm.checkCalendarMode(["deliverables", "tasks"])
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-item item__deliverable__type"
                                  },
                                  [
                                    _c("label", [_vm._v("Deliverable Type")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "deliverable-type-wrap" },
                                      [
                                        _c("multiselect", {
                                          ref: "deliverableTypeFilter",
                                          attrs: {
                                            options: _vm.deliverableTypes,
                                            "show-labels": false,
                                            multiple: true,
                                            "open-direction": "bottom",
                                            label: "name",
                                            "track-by": "id",
                                            "hide-selected": true,
                                            "close-on-select": false,
                                            "clear-on-select": false
                                          },
                                          model: {
                                            value:
                                              _vm.filterQuery.deliverableType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterQuery,
                                                "deliverableType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filterQuery.deliverableType"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__department" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("label", [_vm._v("Department")]),
                                    _vm._v(" "),
                                    _vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "float-right csm-checkbox",
                                            attrs: {
                                              id: "no-department",
                                              name: "no-department",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.filterQuery.noDepartment ==
                                                "accepted"
                                                  ? (_vm.filterQuery.department = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery.noDepartment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "noDepartment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.noDepartment"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "No\n                      Department"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-wrap" },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        ref: "departmentFilter",
                                        attrs: {
                                          "open-direction": "bottom",
                                          label: "name",
                                          "track-by": "id",
                                          options: _vm.allActiveDepartments,
                                          "hide-selected": true,
                                          "show-labels": false,
                                          multiple: true,
                                          "close-on-select": false,
                                          "clear-on-select": false
                                        },
                                        on: {
                                          select: function($event) {
                                            _vm.filterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) +
                                                              " options\n                          selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1090287252
                                        ),
                                        model: {
                                          value: _vm.filterQuery.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.department"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("template", { slot: "noOptions" }, [
                                          _vm._v(
                                            "Start typing to find departments."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "noResult" }, [
                                          _vm._v(
                                            "No results. Please try changing the search query."
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mt-2 csm-checkbox",
                                        attrs: {
                                          id: "no-department",
                                          name: "no-department",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noDepartment ==
                                            "accepted"
                                              ? (_vm.filterQuery.department = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noDepartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noDepartment",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.noDepartment"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "No\n                    Department"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.checkCalendarMode(["deliverables", "tasks"])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__tag" },
                                  [
                                    _c("label", [_vm._v("Tag")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tag-wrap" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            ref: "tagFilter",
                                            attrs: {
                                              options: _vm.tags,
                                              "show-labels": false,
                                              multiple: true,
                                              "open-direction": "bottom",
                                              label: "name",
                                              "track-by": "id",
                                              "hide-selected": true,
                                              "close-on-select": false,
                                              "clear-on-select": false,
                                              loading: _vm.isTagsLoading,
                                              "preserve-search": true
                                            },
                                            on: {
                                              "search-change": _vm.onTagSearch
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var values = ref.values
                                                    var search = ref.search
                                                    var isOpen = ref.isOpen
                                                    return [
                                                      values.length && !isOpen
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiselect__single"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  values.length
                                                                ) +
                                                                  " options\n                          selected"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1090287252
                                            ),
                                            model: {
                                              value: _vm.filterQuery.tag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "tag",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.tag"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noOptions" },
                                              [
                                                _vm._v(
                                                  "Start typing to find tags."
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noResult" },
                                              [
                                                _vm._v(
                                                  "No results. Please try changing the search query."
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkCalendarMode(["deliverables", "tasks"])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__project" },
                                  [
                                    _c("label", [_vm._v("Project")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "project-wrap" },
                                      [
                                        _c("multiselect", {
                                          ref: "projectFilter",
                                          attrs: {
                                            options: _vm.allProjects,
                                            "show-labels": false,
                                            multiple: true,
                                            "open-direction": "bottom",
                                            label: "title",
                                            "track-by": "id",
                                            "hide-selected": true,
                                            "close-on-select": false,
                                            "clear-on-select": false,
                                            "preserve-search": true
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function(ref) {
                                                  var values = ref.values
                                                  var search = ref.search
                                                  var isOpen = ref.isOpen
                                                  return [
                                                    values.length && !isOpen
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "multiselect__single"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                values.length
                                                              ) +
                                                                " options\n                          selected"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            1090287252
                                          ),
                                          model: {
                                            value: _vm.filterQuery.project,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterQuery,
                                                "project",
                                                $$v
                                              )
                                            },
                                            expression: "filterQuery.project"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filter-item item__date",
                              class: {
                                "filter-item-no-border": _vm.isCalendarView
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "due__created__dates" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.dueDateLabel))
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "picker",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customDueDateRanges
                                        },
                                        on: { update: _vm.onUpdateDueDate },
                                        model: {
                                          value: _vm.filterQuery.dateRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateRange",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.dateRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$router.currentRoute.name ==
                                    "dashboard" ||
                                  _vm.$router.currentRoute.name == "myWeek"
                                    ? _c(
                                        "div",
                                        [
                                          _c("label", { staticClass: "mt-2" }, [
                                            _vm._v("Task Due Date")
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("date-range-picker", {
                                            ref: "picker",
                                            attrs: {
                                              autoApply: true,
                                              ranges: _vm.customDueDateRanges
                                            },
                                            on: {
                                              update: _vm.onUpdateTaskDueDate
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery.taskDateRange,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "taskDateRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.taskDateRange"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-2" }, [
                                        _vm._v("Created")
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "pickerDateCreated",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customCreatedDateRanges
                                        },
                                        on: { update: _vm.onUpdateDateCreated },
                                        model: {
                                          value:
                                            _vm.filterQuery.dateCreatedRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateCreatedRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.dateCreatedRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.checkCalendarMode([
                                    "deliverables",
                                    "tasks"
                                  ])
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "mt-lg-2" },
                                            [_vm._v("Completed")]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("date-range-picker", {
                                            ref: "pickerDateCompleted",
                                            attrs: {
                                              autoApply: true,
                                              ranges:
                                                _vm.customCompletedDateRanges
                                            },
                                            on: {
                                              update: _vm.onUpdateDateCompleted
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery
                                                  .dateCompletedRange,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "dateCompletedRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.dateCompletedRange"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.checkCalendarMode(["deliverables", "tasks"])
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "filter-item item__priority filter-item-no-border"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priority__filter" },
                                    [
                                      _c("label", [_vm._v("Priority")]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "filter-rating",
                                          on: { click: _vm.setPriority }
                                        },
                                        [
                                          _c("vue-star-rate", {
                                            attrs: {
                                              rateRange:
                                                _vm.filterQuery.priorityFilter,
                                              maxIcon: 5,
                                              iconHeight: 17,
                                              iconWidth: 17,
                                              hasCounter: false,
                                              iconColor: "var(--wf-primary)",
                                              iconColorHover:
                                                "var(--wf-primary)",
                                              iconShape: "circle"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "priority__sort" }, [
                                    _c("label", { staticClass: "mt-2" }, [
                                      _vm._v("Sort by Priority")
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    !_vm.isGlobalSearchRoute
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-group add-new__global_search sorting main__filter"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-theme header-filter-btns dropdown-toggle",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                  "aria-haspopup": "true",
                                                  "aria-expanded": "false"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Sort\n                      "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-sort text-primary float-right"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dropdown-menu" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.setSort(
                                                          "priorityDesc"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Priority Decending")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.setSort(
                                                          "priorityAsc"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Priority Ascending")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "item__reset" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "theme",
                                      title: "Reset All Filter",
                                      size: "sm"
                                    },
                                    on: { click: _vm.resetFilter }
                                  },
                                  [_c("i", { staticClass: "fas fa-undo" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "d-block d-lg-none",
                                    attrs: {
                                      variant: "theme",
                                      title: "Close Filter Popup",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.popover.$emit("close")
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-times" })]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isFilterActive(),
                                expression: "isFilterActive()"
                              }
                            ],
                            key: "filterKey" + _vm.reloadCounter,
                            staticClass: "d-none d-md-block mt-3 test1"
                          },
                          [
                            _c("label", [_vm._v("Click to remove filters :")]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-primary mr-2 mb-2",
                                style: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.filterQuery.query = null
                                    _vm.searchQuery = ""
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.filterQuery.query))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.status, function(status) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge mr-2 mb-2",
                                  style: {
                                    cursor: "pointer",
                                    color: "var(--wf-secondary)",
                                    backgroundColor: status.color
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(status)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(status.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.outlet, function(outlet) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(outlet)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(outlet.name))]
                              )
                            }),
                            _vm._v(" "),
                            Array.isArray(_vm.filterQuery.deliverableType)
                              ? _c(
                                  "span",
                                  _vm._l(
                                    _vm.filterQuery.deliverableType,
                                    function(deliverableType) {
                                      return _c(
                                        "span",
                                        {
                                          staticClass:
                                            "badge badge-primary mr-2 mb-2",
                                          style: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeFilter(
                                                deliverableType
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(deliverableType.name))]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : typeof _vm.filterQuery.deliverableType !=
                                "undefined"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "deliverableType"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterQuery.deliverableType.name
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.priorityFilter > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "resetPriorityFilter"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Priority " +
                                        _vm._s(_vm.filterQuery.priorityFilter)
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isGlobalSearchRoute && _vm.filterQuery.sort
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge mr-2 mb-2 bg-primary cursor-pointer",
                                    staticStyle: {
                                      color: "var(--wf-secondary)"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "resetDeliverableSort"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterQuery.sort == "priorityDesc"
                                          ? "Priority Descending"
                                          : "Priority Ascending"
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.coordinator, function(
                              coordinator
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(coordinator)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(coordinator.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter("filterByDate")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.dueDateLabel) +
                                        ": " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateRange.startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateRange.endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByTaskDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByTaskDate"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Task Due Date: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.taskDateRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        "\n                - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.taskDateRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterNoDueDate == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.filterNoDueDate = false
                                      }
                                    }
                                  },
                                  [_vm._v("No " + _vm._s(_vm.dueDateLabel))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterNoTaskDueDate == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.filterNoTaskDueDate = false
                                      }
                                    }
                                  },
                                  [_vm._v("No Task Due Date")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDateCreated
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByDateCreated"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Created: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCreatedRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCreatedRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDateCompleted
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByDateCompleted"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Completed: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCompletedRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCompletedRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.tag, function(tag) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(tag)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(tag.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.department, function(
                              department
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(department)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(department.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.project, function(project) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(project)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(project.title))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.noDepartment == "accepted"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.noDepartment =
                                          "not_accepted"
                                      }
                                    }
                                  },
                                  [_vm._v("No Department")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.noOutlet == "accepted"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.noOutlet =
                                          "not_accepted"
                                      }
                                    }
                                  },
                                  [_vm._v("No Outlet")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isCalendarView
                      ? _c(
                          "div",
                          { staticClass: "ml-2 calendar-type-control" },
                          [
                            _c(
                              "label",
                              { staticClass: "btn-theme date-filter-triggers" },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "deliverables",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "deliverables",
                                      value: "deliverables",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode(
                                          "deliverables"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Deliverables\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn-theme ml-2 date-filter-triggers"
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "projects",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "projects",
                                      value: "projects",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode(
                                          "projects"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Projects\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isGlobalSearchRoute &&
                    !_vm.isCalendarView &&
                    _vm.$router.currentRoute.name != "mediaCallPage" &&
                    _vm.$router.currentRoute.name != "socialMedia"
                      ? _c("div", { staticClass: "new-deliverables ml-2" }, [
                          _c(
                            "div",
                            { staticClass: "btn-group wider-filter-only" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn-theme btn-split-button header-filter-btns",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.createNewDeliverable()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "New\n                " +
                                      _vm._s(_vm.getBaseDeliverableType())
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "fas text-primary float-right fa-plus fa-fw"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasMultipleDeliverableType
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn-theme dropdown-toggle dropdown-toggle-split btn-split-button",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v("Toggle Dropdown")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right"
                                },
                                _vm._l(_vm.newDeliverableTypes, function(
                                  type,
                                  i
                                ) {
                                  return _c(
                                    "a",
                                    {
                                      key: i,
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.createDeliverableDropdownClick(
                                            type
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(type.name))]
                                  )
                                }),
                                0
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mobile-filter-only" }, [
                            _vm.hasMultipleDeliverableType
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-theme header-filter-btns dropdown-toggle",
                                    attrs: {
                                      type: "button",
                                      "data-toggle": "dropdown",
                                      "aria-expanded": "false"
                                    }
                                  },
                                  [
                                    _vm._v("New "),
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary float-right fa-plus fa-fw",
                                      staticStyle: { "margin-left": "10px" }
                                    })
                                  ]
                                )
                              : _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-theme header-filter-btns",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.createNewDeliverable()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v("New "),
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary float-right fa-plus fa-fw",
                                      staticStyle: { "margin-left": "10px" }
                                    })
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.hasMultipleDeliverableType
                              ? _c(
                                  "div",
                                  { staticClass: "dropdown-menu" },
                                  _vm._l(_vm.newDeliverableTypes, function(
                                    type,
                                    i
                                  ) {
                                    return _c(
                                      "a",
                                      {
                                        key: i,
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.createDeliverableDropdownClick(
                                              type
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(type.name))]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "mediaCallPage"
                      ? _c("div", { staticClass: "new-deliverables ml-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-theme header-filter-btns",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createDeliverableDropdownClick({
                                    id: "media_call",
                                    name: "Media Call"
                                  })
                                }
                              }
                            },
                            [
                              _vm._v("\n              New Media Call "),
                              _c("i", {
                                staticClass:
                                  "fas text-primary float-right fa-plus fa-fw"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "socialMedia" &&
                    _vm.getSystemSetting("social_media___show_new_post_button")
                      ? _c("div", { staticClass: "new-deliverables ml-2" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-theme header-filter-btns",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.createDeliverableDropdownClick({
                                    id: "social_media",
                                    name: "Social Media"
                                  })
                                }
                              }
                            },
                            [
                              _vm._v("\n              New Social Media Post "),
                              _c("i", {
                                staticClass:
                                  "fas text-primary float-right fa-plus fa-fw"
                              })
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isGlobalSearchRoute && !_vm.isCalendarView
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-expand-ctrls cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "header-filter-btns expand-ctrls",
                                attrs: { variant: "theme" },
                                on: {
                                  click: function($event) {
                                    _vm.expandAll = !_vm.expandAll
                                    _vm.toggleStatusView()
                                  }
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.expandAll,
                                        expression: "!expandAll"
                                      }
                                    ],
                                    staticClass: "icon"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-expand fa-fw"
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.expandAll,
                                        expression: "expandAll"
                                      }
                                    ],
                                    staticClass: "icon"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fas text-primary fa-compress fa-fw"
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "myWeek" ||
                    _vm.$router.currentRoute.name == "dashboard"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "ml-2 mobile-views-section cursor-pointer mobile-filter-only"
                          },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.headerViewSelectModal",
                                    modifiers: { headerViewSelectModal: true }
                                  }
                                ],
                                ref: "MobileViewButton",
                                staticClass: "header-view-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "MobileViewButton"
                                }
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "fas fa-fw fa-eye text-primary"
                                  })
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                ref: "GSCreatedDate",
                                staticClass: "ml-md-2 header-filter-btns",
                                attrs: {
                                  variant: "theme",
                                  id: "GSCreatedDate"
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.$refs.GSCreatedDatePopover.$emit(
                                      "close"
                                    )
                                  },
                                  click: function($event) {
                                    _vm.GSCreatedDatePopover = !_vm.GSCreatedDatePopover
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Created Date\n              "
                                ),
                                _c("i", {
                                  staticClass:
                                    "far fa-calendar-check text-primary"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                ref: "GSCreatedDatePopover",
                                attrs: {
                                  show: _vm.GSCreatedDatePopover,
                                  target: "GSCreatedDate",
                                  triggers: "click blur",
                                  placement: "bottom",
                                  "custom-class":
                                    "filter_popover__gs created-date-popover"
                                },
                                on: {
                                  "update:show": function($event) {
                                    _vm.GSCreatedDatePopover = $event
                                  }
                                }
                              },
                              [
                                _c("date-range-picker", {
                                  ref: "pickerDateCreated",
                                  attrs: {
                                    opens: "inline",
                                    autoApply: true,
                                    ranges: _vm.customCreatedDateRanges
                                  },
                                  on: { update: _vm.onUpdateDateCreated },
                                  model: {
                                    value: _vm.filterQuery.dateCreatedRange,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterQuery,
                                        "dateCreatedRange",
                                        $$v
                                      )
                                    },
                                    expression: "filterQuery.dateCreatedRange"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags" ||
                      _vm.GSDataType == "contacts" ||
                      _vm.GSDataType == "coordinators")
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-md-2 toggle-dept-status cursor-pointer"
                              },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.filterQuery.status[0] != "Active"
                                    },
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.status = ["Active"]
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Active\n                "
                                    ),
                                    _c("i", {
                                      class: [
                                        "fas",
                                        _vm.filterQuery.status.includes(
                                          "Active"
                                        )
                                          ? "fa-toggle-on"
                                          : "fa-toggle-off",
                                        "text-primary",
                                        "float-right",
                                        "ml-2"
                                      ]
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "header-filter-btns",
                                    class: {
                                      "none-active-btn":
                                        _vm.filterQuery.status[0] != "Archived"
                                    },
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.status = ["Archived"]
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Archived\n                "
                                    ),
                                    _c("i", {
                                      class: [
                                        "fas",
                                        _vm.filterQuery.status.includes(
                                          "Archived"
                                        )
                                          ? "fa-toggle-on"
                                          : "fa-toggle-off",
                                        "text-primary",
                                        "float-right",
                                        "ml-2"
                                      ]
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute &&
                    (_vm.GSDataType == "departments" ||
                      _vm.GSDataType == "tags")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search sorting"
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.setSort("usedDesc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Decending")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.setSort("usedAsc")
                                    }
                                  }
                                },
                                [_vm._v("Frequency Ascending")]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute && _vm.GSDataType == "all"
                      ? _c(
                          "div",
                          { staticClass: "btn-group add-new__global_search" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "ml-md-2 header-filter-btns dropdown-toggle",
                                attrs: {
                                  variant: "theme",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [_vm._v("Add")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _vm.userAbilities.createTag ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.$emit("click", "tag")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Tags")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createContact ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.$emit("click", "contact")
                                        }
                                      }
                                    },
                                    [_vm._v("Add Contacts")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createUser
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.$emit(
                                            "click",
                                            "coordinator"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add\n                User")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.userAbilities.createDepartment ||
                              _vm.userAbilities.editMediaCall
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.$emit(
                                            "click",
                                            "department"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Add Departments")]
                                  )
                                : _vm._e()
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute && _vm.GSDataType != "all"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "btn-group add-new__global_search specific-btn",
                            class: !_vm.checkPermissions ? "no-permission" : ""
                          },
                          [
                            _vm.checkPermissions
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "ml-md-2 header-filter-btns action",
                                    attrs: { variant: "theme" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.$emit(
                                          "click",
                                          _vm.GSDataType.substring(
                                            0,
                                            _vm.GSDataType.length - 1
                                          )
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Add\n              "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "text-transform": "capitalize"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.tabType))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _vm.checkPermissions
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-theme dropdown-toggle options",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Toggle Dropdown")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.checkPermissions
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "ml-md-2 header-filter-btns dropdown-toggle",
                                        attrs: {
                                          variant: "theme",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [_vm._v("Add")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _vm.GSDataType != "tags" &&
                                  (_vm.userAbilities.createTag ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.$emit("click", "tag")
                                            }
                                          }
                                        },
                                        [_vm._v("Add Tags")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "contacts" &&
                                  (_vm.userAbilities.createContact ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.$emit(
                                                "click",
                                                "contact"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Contacts")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "coordinators" &&
                                  _vm.userAbilities.createUser
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.$emit(
                                                "click",
                                                "coordinator"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add User")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.GSDataType != "departments" &&
                                  (_vm.userAbilities.createDepartment ||
                                    _vm.userAbilities.editMediaCall)
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.$emit(
                                                "click",
                                                "department"
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Add Departments")]
                                      )
                                    : _vm._e()
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3 filter-badges" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.filterQuery.query = null
                            _vm.searchQuery = ""
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.filterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.status, function(status) {
                      return !_vm.isGlobalSearchRoute
                        ? _c(
                            "span",
                            {
                              staticClass: "badge mr-2 mb-2",
                              style: {
                                cursor: "pointer",
                                color: "var(--wf-secondary)",
                                backgroundColor: status.color
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeFilter(status)
                                }
                              }
                            },
                            [_vm._v(_vm._s(status.name))]
                          )
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartStatus")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.filterQuery.status[0]))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGlobalSearchRoute && _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartTagSort")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.sort == "usedDesc"
                                  ? "Frequency Descending"
                                  : "Frequency Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.priorityFilter > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetPriorityFilter")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Priority " +
                                _vm._s(_vm.filterQuery.priorityFilter)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isGlobalSearchRoute && _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDeliverableSort")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.sort == "priorityDesc"
                                  ? "Priority Descending"
                                  : "Priority Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.outlet, function(outlet) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(outlet)
                            }
                          }
                        },
                        [_vm._v(_vm._s(outlet.name))]
                      )
                    }),
                    _vm._v(" "),
                    Array.isArray(_vm.filterQuery.deliverableType)
                      ? _c(
                          "span",
                          _vm._l(_vm.filterQuery.deliverableType, function(
                            deliverableType
                          ) {
                            return _c(
                              "span",
                              {
                                staticClass: "badge badge-primary mr-2 mb-2",
                                style: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter(deliverableType)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(deliverableType.name))]
                            )
                          }),
                          0
                        )
                      : typeof _vm.filterQuery.deliverableType != "undefined"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("deliverableType")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.filterQuery.deliverableType.name))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.coordinator, function(coordinator) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.dueDateLabel) +
                                ": " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByTaskDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByTaskDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Task Due Date: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.taskDateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.taskDateRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterNoDueDate == 1
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.filterNoDueDate = false
                              }
                            }
                          },
                          [_vm._v("No " + _vm._s(_vm.dueDateLabel))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterNoTaskDueDate == 1
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.filterNoTaskDueDate = false
                              }
                            }
                          },
                          [_vm._v("No Task Due Date")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCompleted
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCompleted")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Completed: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange
                                      .startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByPublishDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByPublishDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Date to Post: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.datePublishRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                "\n            - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.datePublishRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.tag, function(tag) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(tag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.department, function(department) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(department)
                            }
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.project, function(project) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(project)
                            }
                          }
                        },
                        [_vm._v(_vm._s(project.title))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.noDepartment == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noDepartment = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Department")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.noOutlet == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noOutlet = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Outlet")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.overdue
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("overdue")
                              }
                            }
                          },
                          [_vm._v("overdue")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.today
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("today")
                              }
                            }
                          },
                          [_vm._v("today")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.thisWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("thisWeek")
                              }
                            }
                          },
                          [_vm._v("this week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.nextWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("nextWeek")
                              }
                            }
                          },
                          [_vm._v("next week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.upcoming
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("upcoming")
                              }
                            }
                          },
                          [_vm._v("upcoming")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.noDeadline
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("noDeadline")
                              }
                            }
                          },
                          [_vm._v("no deadline")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-5 col-md-4 col-4 text-right right-side" },
            [
              _c(
                "div",
                { staticClass: "logo-user" },
                [
                  _c("HeaderNotification"),
                  _vm._v(" "),
                  _c("LoggedInUser"),
                  _vm._v(" "),
                  _c("Logo")
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme ml-md-2 header-filter-btns dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _vm._v("\n              Sort\n              "),
        _c("i", { staticClass: "fas fa-sort text-primary float-right" })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }